export default __webpack_public_path__ + "media/zurb/img/legacy/axe/2-b2201b120e14ba159762cdbf43d178cd.jpg";